import React, { useContext, useEffect, useRef, useState } from 'react'
import { Alert } from '../utils/Alert'
import EmployeeContext from '../utils/EmpDetails/EmployeeProvider'
import { companydetailnew, employeedetails, glUsrDataViaEmail, fetchGstTurnOverData, serviceVintage, apiAssignToCompany, fetcheEmployeeSearchDid, getSTSID } from '../services/merpservices'
import { glusr_details, maskGlusrFields } from '../services/userservice'
import CryptoJS from "crypto-js";


// CSS
import '../assets/css/bootstrap-icons.css'
import '../assets/css/bootstrap.min.css'
import '../assets/css/fonts.css'
import '../assets/css/media-query.css'
import '../assets/css/style.css'
import { gaEvent } from '../utils/GoogleAnalytics/gatracking'
import { Glusr_identification_Creation } from '../services/loginIdentify'
import CustomerDetails from '../CustomerDetails/CustomerDetails'
import KnowledgeBase from '../components/KnowledgeBase/KnowledgeBase'
import VideoMeet from './VideoMeet'
import DisableReason from '../components/DisableReason/DisableReason'
import getCookie from '../utils/GetCookie/getCookie'
import getIP from '../utils/EmpDetails/getIP'
import IrateFlag from './IrateFlag';
import { maskMobileNumber } from '../utils/Misc/maskMobileNumber';


import { AppGloabalContext, useGlobalContext } from '../context/AppGlobalContext';




export { useGlobalContext };


const SearchBar = ({handleLogout}) => {
  const employeeDetails = useContext(EmployeeContext);
  let empid = "";
  let ak = "";
  let ONum = "";
  let type = "";
  if (employeeDetails !== null) {
    empid = employeeDetails?.empid;
    ak = employeeDetails?.ak;
    ONum = employeeDetails?.ONum;
    type = employeeDetails?.type;
  }
  const [data, setData] = useState([])
  // const [searchTerm, setSearchTerm] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [glid, setGlid] = useState('')
  const [custtype_name, setCusttype_name] = useState('')
  const [companyData, setCompanyData] = useState([])
  const [dropDownValue, setDropDownValue] = useState('')
  const [hambuger, setHamburger] = useState(false);
  const [source, setSource] = useState('');
  const [crtObjectId, setCrtObjectId] = useState('');
  const [dstPhone, setDstPhone] = useState('');
  const [ctcID, setCtcID] = useState('');
  const [turnover, setTurnover] = useState('');
  const [core_business_activity_nature, setCore_business_activity_nature] = useState('');
  const [vintage, setVintage] = useState('');
  const [showVideoMeetTooltip, setShowVideoMeetTooltip] = useState(false);
  const [phtype, setPhtype] = useState(0);
  const [custId, setCustId] = useState("");
  const [assignedGlid, setAssignedGlid] = useState("");
  const [paidFree, setPaidFree] = useState("");
  const [verticalId, setVerticalId] = useState("");
  const [gluserDisableReasons, setGluserDisableReasons] = useState();
  const [parentGlid, setParentGlid] = useState();
  const [glusrData, setGlusrData] = useState({});
  const [displayIrateFlag, setDisplayIrateFlag] = useState(false);
  const [did, setDid] = useState(null);
  const [stsId, setStsId] = useState("");
  const url = new URL(document.location.href);
  const params = url.searchParams;
// ... (move all your params parsing UP here, before useState)


const [searchTerm, setSearchTerm] = useState(() => {
    const sk = params.get('searchkeyword');
    const em = params.get('emailid');
    if (sk) return sk;
    if (em) return em;
    // A bare `phone` param (no searchkeyword/emailid) is populated
    // asynchronously below, once Node returns its masked value — the real
    // number is never decrypted client-side.
    return '';
});




  const [isMasked, setIsMasked] = useState(() => {
  const sk = params.get('searchkeyword');
  const em = params.get('emailid');
  // changeURL() does a full window.location.href navigation, which remounts
  // this component — so the `masked` flag set by getGlid() (see below) must
  // be read back here to survive that reload; a `phone` param alone isn't a
  // reliable signal since a GLID/PNS lookup can also populate `phone` (the
  // resolved company's real number, for other components) while `searchTerm`
  // itself is the GLID/PNS code, not PII.
  const maskedFlag = params.get('masked') === '1';
  return !!((em && em.includes('@')) || (sk && sk.includes('@')) || maskedFlag);
});
  useEffect(() => {
    if (!glid || isTypingRef.current) return;
    const resolvedGlid = nglid ?? glid;
    setStsId("");
    getSTSID(employeeDetails?.empid, employeeDetails?.ak, resolvedGlid)
      .then(res => {
        if (res?.data?.status === 200) setStsId(res?.data?.data?.STSID ?? "");
      })
      .catch(() => {});
  }, [glid]);


  const wrapperRef = useRef(null);
  const dataFoundRef = useRef(false);
  const autoSearchDoneRef = useRef(false);
  const custyTypeFetchedRef = useRef(false);
  const isTypingRef = useRef(false);
  // Every keystroke/paste starts a brand-new async search chain
  // (getData -> companyDetails -> glUserCreation) with no cancellation of
  // whatever chain a previous keystroke already kicked off. companySearch
  // stamps each chain with the current token; each async resumption point
  // below checks it's still the latest before touching state or creating a
  // gluser, so a slower/earlier chain that resolves after a newer keystroke
  // superseded it is discarded instead of acting on stale input.
  const searchTokenRef = useRef(0);


  const emailId = params.get('emailid');
  // Still-encrypted — for API calls that must decrypt server-side rather
  // than receiving plaintext PII from the browser (see fetchDidOfEmployee).
  const rawPhone = params.get('phone') || '';
  const sourceParam = params.get('source');
  const crtObjectIdParam = params.get('crtObjectId');
  const dstPhoneParam = params.get('dstPhone');
  const ctcIDParam = params.get('ctcID');
  const searchkeyword = params.get('searchkeyword');
  const autoSuggest = params.get('dropdown')
  let nglid = params.get('nglid')


  // Node decrypts (if needed) and returns only the MASKED display string —
  // the real number never reaches the browser. Masking preserves length and
  // the first-2/last-3 digits, so the prefix/length checks below
  // (glUserCreation) still work against it.
  const [phone, setPhone] = useState('');
  useEffect(() => {
    if (!rawPhone) {
      setPhone('');
      return;
    }
    maskGlusrFields({ glusr_usr_ph_mobile: rawPhone })
      .then(res => {
        const masked = res?.data?.glusr_usr_ph_mobile || '';
        setPhone(masked);
        // Populate the search box from the auto-loaded phone param once
        // masked — searchkeyword/emailid sources are already handled by the
        // searchTerm lazy init above.
        if (!params.get('searchkeyword') && !params.get('emailid')) {
          setSearchTerm(masked);
          setIsMasked(true);
        }
      })
      .catch(() => setPhone(''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawPhone]);




useEffect(() => {
    if (sourceParam) setSource(sourceParam);
    if (crtObjectIdParam) setCrtObjectId(crtObjectIdParam);
    if (dstPhoneParam) setDstPhone(dstPhoneParam);
    if (ctcIDParam) setCtcID(ctcIDParam);


    if (searchkeyword || emailId || rawPhone) {
        if (!searchkeyword && !emailId && rawPhone) {
          // Send the still-encrypted rawPhone to the API — Node decrypts it,
          // rather than exposing the plaintext number in this request's payload.
          // (searchTerm/phone for display are populated separately, once Node
          // returns the masked value — see the rawPhone effect above.)
          setCompanyData([]);
          getData(empid, ak, '&mobile=' + rawPhone, phone);
        } else if (searchTerm !== "") {
          companySearch(empid, ak, searchTerm); // searchTerm is now correctly set from lazy init
        }
    }
    if (autoSuggest === '1') setIsVisible(false);
}, [empid]);


  const selectDropdownValue = (value) => {
    setDropDownValue(value);
  }


  const searchFunctionalityGA = (ga) => {
    const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
    var searchType = '';
    if (dropDownValue !== "") {
      if (dropDownValue === "1") {
        searchType = 'Mobile Search';
      } else if (dropDownValue === "2") {
        searchType = 'Email Search';
      } else if (dropDownValue === "3") {
        searchType = 'Glid Search';
      } else if (dropDownValue === "4") {
        searchType = 'PNS Search';
      }
    } else {
      if (dropDownValue === "" && emailPattern.test(searchTerm)) {
        searchType = "Smart Email Search"
      } else if (ga === "GLID Search") {
        searchType = "Smart Glid Search"
      } else if (ga === "PNS Search") {
        searchType = "Smart PNS Search"
      } else if (ga === "Mobile Search") {
        searchType = 'Smart Mobile Search';
      }
    }
    gaEvent(searchType !== '' ? searchType : ga, searchType !== '' ? searchType : ga, 'Search', `empid: ${empid} | ucid: ${crtObjectIdParam}`, glid)
  }


  useEffect(() => {
    // Direct GLID lookup — only when no phone/email/searchkeyword is available.
    // When phone or searchkeyword is present, getData is tried first via the
    // searchTerm effect and companyDetails is called only on 204 (empty response).
    if (empid !== "" && nglid && !rawPhone && !emailId && !searchkeyword) {
      companyDetails(empid, ak, nglid, 1);
    }
  }, [empid])


  const toggleVisibility = () => {
    setHamburger(!hambuger);
    setShowVideoMeetTooltip(false)
  };


  const companySearch = (empid, ak, value) => {
    setSearchTerm(value);
    dataFoundRef.current = false;
    // Invalidate whatever chain an earlier keystroke/paste may still have
    // in flight — its async resumption points check this token and bail
    // out rather than applying a now-superseded result.
    const searchToken = ++searchTokenRef.current;
    if (value.length >= 3) {
      if (isNaN(value) && value.includes('@')) {
        var inputParam = '&email=' + value
        getData(empid, ak, inputParam, undefined, searchToken);
        setCompanyData([])
      } else if (value.length >= 7 && value.length <= 15) {
        getData(empid, ak, '&mobile=' + value, value, searchToken);
        // companyDetails is NOT called here — getData already falls back to it on a 204 response
        setCompanyData([])
      } else {
        companyDetails(empid, ak, value, 1, searchToken)
        setData([])
      }
    }
  };


  const glUserCreation = async (value, searchToken) => {
    // Called from companyDetails's 204-fallback with the token that was
    // current when that chain started — if a newer search has since
    // superseded it, don't create a gluser for input that's no longer in
    // the search box. searchByInput (Enter) calls this with no token,
    // which always passes — that's a direct, current user action.
    if (searchToken !== undefined && searchToken !== searchTokenRef.current) return;
    let number = searchTerm
    if (number.length === 12 && /^91/.test(number)) {
      number = number.slice(2)
    }
    const did = await fetchDidOfEmployee(empid, ak, rawPhone);
    // `phone` is Node's MASKED value now (not the real decrypted number), so this
    // equality is an approximation — a real DID that happens to share the same
    // masked shape (same length/prefix/suffix) as the caller's number would be
    // treated as "no distinct DID assigned" even if the middle digits differ.
    if (did === phone){
      setDid(did || null)
    }else{
      if (number.length === 10 && /^[6789]/.test(number)) {
        const ip = await getIP()
        const remoteIp = getCookie('CCIP') || ip.data?.ip;
        // value's truthiness can't tell us whether this is the auto-load
        // path or a manual search — companyDetails's 204-fallback always
        // calls glUserCreation(1) regardless of which one led there.
        // isTypingRef.current is the real signal: it's false only while the
        // search box still holds the value auto-populated from the URL's
        // phone param (Node's MASKED display string, not usable for
        // creation — use the still-encrypted rawPhone instead, which
        // /user/identify decrypts server-side via decryptEncryptedValuesDeep
        // before forwarding upstream). Once the agent has typed or pasted
        // anything, it flips true permanently, and searchTerm/number already
        // holds the real digits they entered, so that's used as-is.
        const identifierForCreation = !isTypingRef.current ? rawPhone : number;
        try {
          const res = await Glusr_identification_Creation(remoteIp, identifierForCreation)
          if (res.data.code === 200) {
            const data = res.data.DataCookie;
            if (value) {
              setGlid(data.glid)
            } else {
              // Use identifierForCreation, not number — number is
              // searchTerm, which is Node's MASKED display string
              // (!isTypingRef.current case, e.g. re-submitting the still
              // auto-populated box after an auto-load creation without
              // typing anything). identifierForCreation is already the
              // correct real value for either case (rawPhone ciphertext or
              // real typed digits) since it's what was actually just sent
              // to Glusr_identification_Creation above.
              changeURL(`&phone=${identifierForCreation}&nglid=${data.glid}`);
            }
          }
        } catch (error) {
          console.log("Error", error)
        }
      }
    }
  }


  const searchByInput = async (inputValue) => {
    if (searchTerm === '') {
      Alert("Kindly Enter correct Mobile No/Email/PNS/GLID to search");
      return
    }
    if (data.length >= 1) {
      setIsMasked(true);
      // Email is never masked or round-tripped through ciphertext, unlike
      // phone — searchTerm/inputValue always holds the real typed (or
      // mount-param) email text regardless of isMasked (that flag only
      // affects EmailMask's display formatting), so it's always safe and
      // correct to reuse it as-is here.
      const isEmailSearch = inputValue.includes('@');
      if (isEmailSearch) {
        changeURL(`&emailid=${inputValue}&nglid=${data[0]?.GLUSR_USR_ID}`)
        searchFunctionalityGA("Email Search")
      } else if (isMasked) {
        // inputValue is the MASKED display string (e.g. "92*****169"), not
        // real, reusable data. nglid alone isn't enough on reload: the
        // header's paidFree/custtype_name display and custyTypeID's trigger
        // are both gated on (rawPhone || emailId) being present, not just
        // nglid — so fetch this GLID's real (still-encrypted) phone the same
        // way getGlid does, and carry that forward instead.
        const targetGlid = data[0]?.GLUSR_USR_ID;
        try {
          const res = await glusr_details(ak, targetGlid);
          const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
          if (glusrPhNo) {
            changeURL(`&phone=${glusrPhNo}&nglid=${targetGlid}&masked=1`);
          } else {
            changeURL(`&nglid=${targetGlid}&masked=1`);
          }
        } catch (error) {
          console.log("Error", error);
        }
        searchFunctionalityGA("Smart Mobile Search");
      } else {
        changeURL(`&phone=${inputValue}&nglid=${data[0]?.GLUSR_USR_ID}`);
        searchFunctionalityGA("Mobile Search");
      }
    } else if (companyData.length >= 1) {
      const glid = companyData[0]?.GLUSR_USR_ID;
      if (searchTerm === glid) {
        searchFunctionalityGA("GLID Search");
      } else {
        searchFunctionalityGA("PNS Search");
      }
      glusrDetails(ak, glid, inputValue);
    } else if (data.length === 0 && companyData.length === 0) {
      // changeURL(`&phone=${inputValue}`);
      glUserCreation()
      searchFunctionalityGA("Mobile Search");
    }
  }


  const fetchDidOfEmployee = async (empid, ak, keyword) => {
    try {
      if(data.length === 0 && companyData.length === 0){
        const res = await fetcheEmployeeSearchDid(empid, ak, keyword);
        if (res?.data?.status === 200) {
          const did = res?.data?.data?.queryData?.[0]?.CAMPAIGN_DID;
          setDid(did?.replace(/^\+91/, '') || null);
          return did?.replace(/^\+91/, '') || null;
        }
      }
      return null;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  };


  const getData = async (empid, ak, inputParam, rawKeyword, searchToken) => {
    try {
      const res = await glUsrDataViaEmail(empid, ak, inputParam);
      // A newer keystroke/paste already started its own chain — this
      // response is for input that's no longer in the search box.
      if (searchToken !== undefined && searchToken !== searchTokenRef.current) return;
      if (res?.data?.status_code === 200) {
        // const result = res?.data?.data;
        let responseData = res?.data
        if (responseData?.data?.length >= 1) {
          setPhtype(1);
          dataFoundRef.current = true;
        };
        // Sorting glids based on custtype weight
        responseData.data.sort((a, b) => {
          const weightA = parseInt(a.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;
          const weightB = parseInt(b.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;








          return weightA - weightB;
        });
        setData(responseData.data);
        if ((rawPhone || emailId) && !isTypingRef.current) {
          const resolvedGlid = nglid ?? responseData?.data[0]?.GLUSR_USR_ID;
          const matchedEntry = responseData.data.find(
            d => String(d.GLUSR_USR_ID) === String(nglid)
          ) ?? responseData.data[0];
          setGlid(responseData?.data[0]?.GLUSR_USR_ID)
          setCusttype_name(matchedEntry.GLUSR_USR_CUSTTYPE_NAME ?? '');
          if (!custyTypeFetchedRef.current) {
            custyTypeFetchedRef.current = true;
            custyTypeID(responseData?.data[0]?.GLUSR_USR_ID);
          }
        }
      } else if (res?.data?.status_code === 204) {
        if (!dataFoundRef.current) {
          // inputParam.split('=')[1] is always the right value here: on an
          // auto-loaded URL phone it's the still-encrypted rawPhone (which
          // /companydetailnew decrypts server-side), and on a manual search
          // it's the literal typed text — never Node's MASKED `phone`
          // display value (rawKeyword used to be preferred here, but a
          // masked string like "94*****864" isn't ciphertext and isn't a
          // real number, so it can never match anything downstream).
          const mobileNumber = inputParam.split('=')[1];
          // Use nglid only when auto-loading the URL's phone param; for a fresh manual
          // search use the typed number.
          const fallbackKeyword = (nglid && mobileNumber === rawPhone) ? nglid : mobileNumber;
          companyDetails(empid, ak, fallbackKeyword, 1, searchToken);
        }
        setData([])
      }
    } catch (error) {
      console.log("Error", error)
    }
  }


  const companyDetails = async (empid, ak, keyword, custtype = 1, searchToken) => {
    if (keyword) {
      try {
        const res = await companydetailnew(empid, ak, keyword);
        // Same staleness guard as getData — a newer search superseded this one.
        if (searchToken !== undefined && searchToken !== searchTokenRef.current) return;
        if (res?.data[0].status === "200") {
          const result = res?.data[0]?.data;
          if (result.length) {
            setPhtype(1);
            setCompanyData(result)
            if ((rawPhone || emailId) && !isTypingRef.current) {
              setGlid(result[0]?.GLUSR_USR_ID)
              if (!custyTypeFetchedRef.current) {
                custyTypeFetchedRef.current = true;
                custyTypeID(result[0]?.GLUSR_USR_ID);
              }
            }
            if (custtype === 1 && !isTypingRef.current) {
              const matchedEntry = result.find(
                r => String(r.GLUSR_USR_ID) === String(nglid)
              ) ?? result[0];
              setCusttype_name(matchedEntry.CUSTTYPE_NAME ?? '');
            }
          } else {
            // Clear any previous search's still-displayed results — without
            // this, a search that goes from finding matches to finding none
            // (e.g. typing another character) left the old autosuggest list
            // showing indefinitely.
            setCompanyData([]);
            glUserCreation(1, searchToken);
          }
        }
      } catch (error) {
        console.log("Error", error)
      }
    }
  }


  const glusrDetails = async (ak, glid, searchkeyword) => {
    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      if (glusrPhNo === null) {
        if (email !== null) {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&emailid=${email}&nglid=${glid}`);
        } else {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&nglid=${glid}`);
        }
      } else {
        changeURL(`&phone=${glusrPhNo}&searchkeyword=${searchkeyword}&nglid=${glid}`);
      }
    } catch (error) {
      console.log("Error", error)
    }
  }


  const changeURL = (param) => {
    const url = `?source=${source}&empid=${empid}&action=search&crtObjectId=${crtObjectId}&dstPhone=${dstPhone}&rsrch=1${param.replace(/\s/g, '')}&origNum=${ONum}&ctcID=${ctcID}&dropdown=1${type ? `&type=${type}` : ''}`;
    window.location.href = url;
  }


  useEffect(() => {
    // Function to handle clicks outside of the div
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);


    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const getGlid = async (glid, custtype_name, index) => {
    // This handler serves two different autosuggest lists: the phone/email
    // result list (`data`, populated only for a raw mobile-number or email
    // search — see companySearch) and the GLID/PNS/company-name list
    // (`companyData`). Only the former means `searchTerm` itself is PII that
    // needs masking — a GLID click can still end up with a `phone` param in
    // the URL below (the resolved company's real number, for other
    // components), but that's not what's displayed here, so it must not
    // trigger masking.
    const isPiiResult = searchTerm.includes('@') || data.length >= 1;
    if (isPiiResult) setIsMasked(true);
    setCusttype_name(custtype_name ?? "")
    setGlid(glid);
    //GA tracking based on auto suggested
    if (data.length >= 1) {
      searchFunctionalityGA(isNaN(searchTerm) ? "Smart Email Search" : "Smart Mobile Search");
    } else if (companyData.length >= 1) {
      searchFunctionalityGA(searchTerm === companyData[0]?.GLUSR_USR_ID ? "Smart GLID Search" : "Smart PNS Search");
    } else {
      searchFunctionalityGA("Smart Mobile Search");
    }


    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      // changeURL() does a full page reload, which wipes the isMasked state set
      // above — persist the masking decision across that reload via a URL flag.
      const maskParam = isPiiResult ? '&masked=1' : '';
      // searchTerm is only real, reusable data for a GLID/PNS/company-name
      // result (companyData) — for a PII result (data) it's either the raw
      // typed value (fine before masking) or the MASKED display string once
      // isMasked flips true, which is garbage to search by on reload. Once
      // this is a PII result we always mask (line above), so drop
      // searchkeyword entirely here and rely on nglid/phone/emailid instead.
      const skParam = isPiiResult ? '' : `&searchkeyword=${searchTerm}`;
      // Pick phone vs email based on what the user actually searched by, not
      // just whichever field glusr_details happens to return non-null —
      // it returns both when the company has both, and always preferring
      // phone here used to be harmless (searchkeyword carried the real
      // searched value and took routing priority on reload) but became a
      // real bug once skParam stopped forwarding searchkeyword for PII
      // results: an email search would silently reload showing the masked
      // mobile instead.
      const isEmailSearch = isPiiResult && searchTerm.includes('@');
      if (isEmailSearch) {
        // Email is never masked or round-tripped through ciphertext, unlike
        // phone — searchTerm is always the real typed email regardless of
        // isMasked (that flag only affects EmailMask's display formatting),
        // so use it directly instead of glusr_details' encrypted field.
        changeURL(`&emailid=${searchTerm}${skParam}&nglid=${glid}${maskParam}`); // passing nglid param in browser URL for getting disable icon
      } else if (glusrPhNo) {
        changeURL(`&phone=${glusrPhNo}${skParam}&nglid=${glid}${maskParam}`);
      } else if (email) {
        // Non-email search that landed on an email-only company (no phone
        // on file) — email here is glusr_details' encrypted field, since we
        // never typed it ourselves in this branch.
        changeURL(`&emailid=${email}${skParam}&nglid=${glid}${maskParam}`);
      } else {
        changeURL(`&nglid=${glid}${maskParam}`);
      }
    } catch (error) {
    }
  }


  const leftHamburger = (val) => {
    if (val === 'report') {
      // Without ?empid=, the new tab's EmployeeProvider never has an empid
      // to fetch employee details for (it parses empid straight from the
      // URL), so CallDetails.jsx's employeeDetails-based "Kindly login"
      // gate stays stuck even for an already-logged-in agent.
      window.open(`/api/data_dump?empid=${empid}`, '_blank');
    } else if (val === 'admin') {
      window.open('https://vendors.intermesh.net/Models/addRemoveCliDispositions.php')
    } else if (val === 'logout') {
      handleLogout();
      // window.location.href = 'https://vendors.intermesh.net/Controllers/inBoundCenter.php?logout=1'
    }
  }


  const gstTurnover = async (empid, ak, glid) => {
    // ak is always empty now (jwt_token is httpOnly, Node injects the real
    // value server-side) — gate on empid instead.
    if (empid !== "") {
      try {
        const response = await fetchGstTurnOverData(empid, ak, glid)
        if (response?.data?.status === 200) {
          if (response?.data?.Data.code === 200) {
            const gst_turnover = response?.data?.Data?.data?.values[0].shortname_turnover;
            setTurnover(gst_turnover === 'NA' ? "" : `|  ₹ ${gst_turnover}`)
            setCore_business_activity_nature(response?.data?.Data?.data?.values[0].core_business_activity_nature)
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }


  const service_vintage = async (empid, ak, glid) => {
    if (empid !== '') {
      try {
        const response = await serviceVintage(empid, ak, glid);
        if (response?.data?.status === 200) {
          const data = response?.data?.data[0].SERVICE_VINTAGE;
          if (data) {
            const serviceVintage = data.split(" ");
            if (serviceVintage[0] !== "0") {
              setVintage(`| ${serviceVintage[0]} Y`);
            } else if (serviceVintage[2] !== "0") {
              setVintage(`| ${serviceVintage[2]} M`);
            } else {
              setVintage(`| ${serviceVintage[5]} D`);
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }


  useEffect(() => {
    // ak never changes (always ""), so [ak] would never re-fire this once
    // empid loads — empid is the real "has this loaded" signal now.
    if (nglid !== '' && nglid !== null) {
      gstTurnover(empid, ak, nglid)
      service_vintage(empid, ak, nglid)
    }
  }, [empid])




  const allowed_emp_ids = ["50060", "29545", "37647", "85789", "93639", "93805", "100659", "64374", "94090", "107140", "113875"]


  const paidCustArray = [1, 2, 7, 10, 12, 13, 15, 31, 48];


  const custyTypeID = async (glid) => {
    const resolvedGlid = nglid ?? glid;
    let res = await apiAssignToCompany(resolvedGlid, 1);
    if (res?.data?.status === 200) {
      const custID = res?.data?.GLUSR_USR_CUSTTYPE_ID === "" ? 0 : res?.data?.GLUSR_USR_CUSTTYPE_ID;
      setCustId(parseInt(custID));
      setAssignedGlid(resolvedGlid);
      if (paidCustArray.includes(parseInt(custID))) {
        setPaidFree("Paid | ")
      } else {
        setPaidFree("Free | ")
      }
    }
  }


  return (
    <AppGloabalContext.Provider value={{ paidFree, setGluserDisableReasons, custId, assignedGlid, parentGlid, setParentGlid, glid, glusrData, setGlusrData, displayIrateFlag, setDisplayIrateFlag, verticalId, setVerticalId, did, stsId, setStsId, custtype_name }}>
    <>
      <header className='h-42'>
        <div className="container-fluid">
          <div className="main-bar">
            <div className="d-flex justify-content-between align-items-center">
              <div className="left-sec">
                <div className="input-box h-38">
                  <div className="input-group">
                    <input
                      type="text"
                      id="searchno_email"
                      className="form-control h-38"
                      placeholder="Mobile, Email, GLID or PNS"
                      aria-label="Dollar amount (with dot and two decimal places"
                      value={searchTerm.includes('@')
                        // Email is shown as-is, never masked — only phone
                        // numbers get masked in this box.
                        ? searchTerm
                        // The phone===searchTerm equality only means "mask" when it comes from
                        // the URL a fresh page load already carried (e.g. the caller's number
                        // pre-attached to an inbound call) — isTypingRef flips true forever on
                        // the first keystroke, so once the agent is actually typing, a coincidental
                        // digit match with that stale `phone` param must NOT trigger masking mid-entry.
                        : (isMasked || (!isTypingRef.current && phone && searchTerm === phone))
                        ? maskMobileNumber(searchTerm)
                        : searchTerm
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (searchTerm.includes('@')) setIsMasked(true);
                          searchByInput(searchTerm);
                        }
                      }}
                      onPaste={(e) => {
                        isTypingRef.current = true;
                        setIsMasked(false);
                        companySearch(empid, ak, e.target.value);
                      }}
                      onChange={(e) => {
                        isTypingRef.current = true;
                        setIsMasked(false);
                        companySearch(empid, ak, e.target.value);
                      }}
                      onClick={(e) => {
                        setHamburger(false);
                        setShowVideoMeetTooltip(false)
                        setIsVisible(true);
                      }}
                    />
                    <div className="search-result">
                      {searchTerm === "" ? (
                        ""
                      ) : data.length === 0 ? (
                        <>
                          {companyData.length === 0 ? (
                            <></>
                          ) : (
                            <div
                              className="resultbox fs-outfit"
                              style={{ display: isVisible ? "block" : "none" }}
                              ref={wrapperRef}
                            >
                              {companyData.slice(0, 3).map((data, i) => {
                                const {
                                  GLUSR_USR_COMPANYNAME,
                                  GLUSR_USR_ID,
                                  CUSTTYPE_NAME,
                                } = data;
                                return (
                                  <div
                                    key={`${GLUSR_USR_ID}{i}`}
                                    className={
                                      nglid === null || nglid === String(GLUSR_USR_ID)
                                        ? "companylist cp fw600 fs-outfit"
                                        : "companylist1 cp fw600 fs-outfit"
                                    }
                                    onClick={() => {
                                      getGlid(GLUSR_USR_ID, CUSTTYPE_NAME, i);
                                    }}
                                  >
                                    <span
                                      id="glusr_company"
                                      className={
                                        nglid === null
                                          ? "colorgreen fw500 fs-outfit"
                                          : nglid === String(GLUSR_USR_ID)
                                            ? "colorgreen fw500 fs-outfit"
                                            : "fw500 fs-outfit"
                                      }
                                    >
                                      {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                    </span>{" "}
                                    <br />
                                    <span id="cust_type" className="fw400">
                                      {CUSTTYPE_NAME}
                                    </span>{" "}
                                    <br />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          className="resultbox fs-outfit"
                          style={{ display: isVisible ? "block" : "none" }}
                          ref={wrapperRef}
                        >
                          {data.slice(0, 4).map((data, i) => {
                            const {
                              GLUSR_USR_COMPANYNAME,
                              GLUSR_USR_FIRSTNAME,
                              GLUSR_USR_LASTNAME,
                              GLUSR_USR_ID,
                              GLUSR_USR_CUSTTYPE_NAME,
                              FK_PARENT_GLUSR_ID,
                            } = data;
                            const fname = GLUSR_USR_FIRSTNAME ?? "";
                            const lname = GLUSR_USR_LASTNAME ?? "";
                            return (
                              <div
                                key={GLUSR_USR_ID}
                                className={
                                  nglid === null || nglid === String(GLUSR_USR_ID)
                                    ? "companylist fs-outfit"
                                    : "companylist1"
                                }
                                onClick={() => {
                                  getGlid(
                                    GLUSR_USR_ID,
                                    GLUSR_USR_CUSTTYPE_NAME,
                                    i
                                  );
                                }}
                              >
                                <span
                                  className={
                                    nglid === null
                                      ? "colorgreen"
                                      : nglid === String(GLUSR_USR_ID)
                                        ? "colorgreen fw500"
                                        : ""
                                  }
                                >
                                  {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                </span>
                                <br />
                                <span className="fw400">
                                  {fname + " " + lname}
                                </span>
                                <br />
                                <span className="fw400">
                                  {GLUSR_USR_CUSTTYPE_NAME}
                                  {FK_PARENT_GLUSR_ID !== null ? (
                                    <>
                                      {" "}
                                      <br />{" "}
                                      <span
                                        className={
                                          nglid === String(GLUSR_USR_ID)
                                            ? "colorgreen fw500"
                                            : ""
                                        }
                                      >
                                        Parent({FK_PARENT_GLUSR_ID})
                                      </span>{" "}
                                    </>
                                  ) : (
                                    " "
                                  )}
                                </span>{" "}
                                <br />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <span
                      className="input-group-text"
                      onClick={() => {
                        if (searchTerm.includes('@')) setIsMasked(true);
                        searchByInput(searchTerm);
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="right-sec">
                <ul>
                  <IrateFlag />
                  <li>
                    <a>
                      {gluserDisableReasons && <DisableReason disableDetails={gluserDisableReasons}/>}
                      {(rawPhone || emailId) && `${paidFree}`}

                      {nglid ?? glid}
                      {(rawPhone || emailId) && custtype_name && (
                        <> | <span className="custtype">{custtype_name} {turnover} {vintage}
                          <VideoMeet glid={glid} ak={ak}/>
                        </span></>
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                    >
                      <i className="bi bi-list" onClick={() => {
                        toggleVisibility();
                      }}></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {allowed_emp_ids.includes(empid) ? (
          <div style={{ display: hambuger ? "block" : "none" }}>
            <div className="Frame1000009573 cp">
              <div
                className="reportbtn"
                onClick={() => leftHamburger("report")}
              >
                Report
                <div className="line85"></div>
              </div>
              <div
                className="adminbtn"
                onClick={() => leftHamburger("admin")}
              >
                Admin
                <div className="line85"></div>
              </div>
              <div
                className="logout-btn"
                onClick={() => leftHamburger("logout")}
              >
                Logout
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: hambuger ? "block" : "none" }}>
            <div className="Frame1000009573 cp">
              {(employeeDetails?.FK_IIL_DESIGNATION_ID != "2"  || empid === "117113" || empid === "113881" || empid === "113870") && (
                <div
                  className="reportbtn"
                  onClick={() => leftHamburger("report")}
                >
                  Report
                  <div className="line85"></div>
                </div>
              )}
              <div
                className="logout-btn"
                onClick={() => leftHamburger("logout")}
              >
                Logout
              </div>
            </div>
          </div>
        )}
      </header>
      {
        // ak is always empty now (jwt_token is httpOnly, injected
        // server-side by Node) — gate solely on empid.
        empid !== "" ? (
          <>
            <CustomerDetails empid={empid} ak={ak} glid={nglid ?? glid} businessNature={core_business_activity_nature} phtype={phtype} />
          </>
        ) : (
          ""
        )
      }
      <KnowledgeBase />
    </>
    </AppGloabalContext.Provider>
  );
}


export default SearchBar
